var changeDelegate, deserializeItem, deserializeItems, repeat, serializeItemBody, tagsHelper, text;

tagsHelper = require('./tags');

changeDelegate = require('./change-delegate');

repeat = require('../../util').repeat;

text = require('../text');

serializeItemBody = function(item, bodyAttributedString, options, context) {
  var attributeName, bodyString, encodedAttributes, i, itemClone, len, ref;
  bodyString = bodyAttributedString.string;
  if (item.outline.changeDelegate !== changeDelegate) {
    itemClone = item.clone();
    encodedAttributes = [];
    ref = item.attributeNames;
    for (i = 0, len = ref.length; i < len; i++) {
      attributeName = ref[i];
      if (tagsHelper.encodesAttributeName(attributeName)) {
        tagsHelper.addTag(itemClone, attributeName, itemClone.getAttribute(attributeName));
      }
    }
    if (encodedAttributes.length) {
      encodedAttributes = encodedAttributes.join(' ');
      if (bodyString.length) {
        encodedAttributes = ' ' + encodedAttributes;
      }
      bodyString += encodedAttributes;
    }
  }
  return context.lines.push(repeat('\t', item.depth - options.baseDepth) + bodyString);
};

deserializeItem = function(itemString, outline) {
  var body, indent, item, removedLength;
  item = outline.createItem();
  indent = itemString.match(/^\t*/)[0].length + 1;
  body = itemString.substring(indent - 1);
  item.indent = indent;
  item.bodyString = body;
  if (item.outline.changeDelegate !== changeDelegate) {
    removedLength = 0;
    parseTags(body, function(tag, value, match) {
      var index;
      item.setAttribute(tag, value);
      index = match.index - removedLength;
      body = body.substring(0, index) + body.substring(index + match[0].length);
      return removedLength += match[0].length;
    });
  }
  return item;
};

deserializeItems = function(itemsString, outline, options) {
  if (options == null) {
    options = {};
  }
  return text.deserializeItems(itemsString, outline, options, deserializeItem);
};

module.exports = {
  changeDelegate: require('./change-delegate'),
  beginSerialization: text.beginSerialization,
  beginSerializeItem: text.beginSerializeItem,
  serializeItemBody: serializeItemBody,
  endSerializeItem: text.endSerializeItem,
  endSerialization: text.endSerialization,
  emptyEncodeLastItem: text.emptyEncodeLastItem,
  deserializeItems: deserializeItems,
  itemPathTypes: {
    'project': true,
    'task': true,
    'note': true
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/serializations/taskpaper/index.js
 ** module id = 196
 ** module chunks = 0
 **/